import { isNullOrEmpty } from "./utils";

const BASE_URL = "https://appscrap.vgapp.cl/api/";
//const BASE_URL = "http://localhost:8085/";

export const URLS = {
    MAIN_URL: BASE_URL,
    LOGIN: "https://vgapp.cl/ownapps/login.php",
    UPLOAD_FILE: BASE_URL + "nodescraper/upload",
    DOWNLOAD_FILE: BASE_URL + "nodescraper/download",
    DELETE_PROCESS: BASE_URL + "nodescraper/deleteBackgroundProcess",
    GET_COMMUNES: BASE_URL + "nodescraper/communes",
    GET_BACKGROUND_PROCESS: BASE_URL + "nodescraper/backgroundProcess",
    CLEAN_BACKGROUND_PROCESS: BASE_URL + "nodescraper/cleanBckgroundProcess",
    PJUD_BACKGROUND: BASE_URL + "nodescraper/pjudBg",
    SEIA_BACKGROUND: BASE_URL + "nodescraper/seiaBg"
};

/**
 * Make a new REST request to the server.
 * @param {*} url 
 * @param {*} params 
 * @param {*} reType 
 */
export const httpRequest = (url, params, reType) =>{
  
    return new Promise( (resolve, reject) => {

        if (isNullOrEmpty(url))
            return reject("Error empty url");

        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        
        let opt = {
            method: reType, 
            mode: "cors",
            headers: headers
        };

        if (!isNullOrEmpty(params)) {
            opt["body"] = JSON.stringify(params);
        }
        
        fetch(url, opt)
            .then( (response) => {
                
                return [response.json(), response.status];
            })
            .then( (data) => {
                
                let status = data[1];
                if (status !== 200)
                    console.log ("Error en " + url + ", status: " + status);
               
                resolve(data[0]);
            })
            .catch( (err) => {

                if (false === err instanceof Error &&  err.type && err.type === 'unparsable') {
                    reject(err.body);
                    return;
                }

                reject(err);
            });
    });
}

export const httpUploadFile = (url, params) => {

    return new Promise ( (resolve, reject) => {

        const data = new FormData();
        const keys = Object.keys(params);
        for (let idx = 0; idx < keys.length; idx++) {
            data.append(keys[idx], params[keys[idx]]);
        }

        fetch(url, { method: 'POST', body: data})
            .then ( (response) => {
                return [response.json(), response.status];
            })
            .then ( (data) => {
                let status = data[1];
                if (status !== 200)
                    console.log ("Error en " + url + ", status: " + status);
               
                resolve(data[0]);
            })
            .catch ( (err) => {
                console.log ("err: ", err);
                reject(err);
            });
    });
};